export const SIGN_OUT_USER = 'authentication/SIGN_OUT_USER'
export const SIGN_IN_USER_USER = 'authentication/SIGN_IN_USER_USER'
